// extracted by mini-css-extract-plugin
export default {"wrapper":"ZSZY1phv","slide":"vCCqOvOq","button":"XIxoy7tw","tokenIcon":"SS8KpgmL","content":"ISsYr_9r","chevronIcon":"D_7DrGaN"};